import { useState, useEffect, useMemo } from 'react';

/** Matches icons in `EditorActionToolbar.jsx` for visual consistency. */
function TipToolIcon({ name, className = '' }) {
  const cn = `shrink-0 w-[18px] h-[18px] text-amber-900 ${className}`.trim();
  switch (name) {
    case 'magicwand':
      return (
        <svg className={cn} viewBox="0 0 512 512" fill="currentColor" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
          <polygon points="501.551,468.052 468.049,501.552 207.092,240.602 207.094,240.59 240.595,207.101" />
          <path d="M240.595 207.101l-33.502 33.489-.001.011-59.07-59.069c-9.254-9.253-9.253-24.252.001-33.502 4.62-4.626 10.683-6.945 16.741-6.944 6.071-.001 12.132 2.318 16.759 6.944l59.072 59.071z" />
          <path d="M508.939 460.663L247.984 199.712l-59.07-59.07c-6.452-6.451-15.027-10.005-24.152-10.005-9.116 0-17.685 3.555-24.125 10.003-6.45 6.447-10.003 15.02-10.003 24.139-.001 9.119 3.551 17.693 10 24.141l59.07 59.069 260.956 260.95c2.041 2.041 4.715 3.06 7.388 3.06 2.674 0 5.348-1.021 7.388-3.06l33.503-33.5c1.959-1.959 3.06-4.617 3.06-7.388 0-2.772-1.101-5.428-3.061-7.388zM151.532 164.781c0-3.536 1.377-6.86 3.886-9.366 2.498-2.501 5.816-3.879 9.352-3.879s6.862 1.379 9.366 3.884l51.681 51.68-18.728 18.721-51.679-51.676c-2.501-2.502-3.878-5.828-3.878-9.364zm316.517 321.994L221.866 240.598l14.51-14.506 4.217-4.215 246.18 246.175-18.724 18.723z" />
          <path d="M96.609 81.842a10.45 10.45 0 00-14.778 0 10.45 10.45 0 000 14.777l24.17 24.168a10.45 10.45 0 0014.776 0 10.45 10.45 0 000-14.777L96.609 81.842z" />
          <path d="M62.694 77.483a10.45 10.45 0 0014.776 0 10.45 10.45 0 000-14.777L65.067 50.302a10.45 10.45 0 00-14.778 0 10.45 10.45 0 000 14.777l12.405 12.404z" />
          <path d="M99.682 171.709c0-5.771-4.678-10.449-10.449-10.449L10.449 161.26C4.679 161.259 0 165.938 0 171.708c0 5.771 4.678 10.449 10.449 10.449l78.784.001c5.771 0 10.449-4.679 10.449-10.449z" />
          <path d="M59.912 268.718l-9.627 9.626a10.45 10.45 0 000 14.777 10.45 10.45 0 0014.776 0l9.627-9.626a10.45 10.45 0 000-14.777 10.45 10.45 0 00-14.776 0z" />
          <path d="M105.992 222.638l-27.489 27.489a10.45 10.45 0 000 14.778 10.45 10.45 0 0014.776 0l27.49-27.49a10.45 10.45 0 000-14.778 10.45 10.45 0 00-14.777 0z" />
          <path d="M171.71 243.728c-5.77 0-10.449 4.678-10.449 10.449v78.787c0 5.771 4.679 10.449 10.449 10.449s10.449-4.678 10.449-10.449v-78.787c0-5.771-4.679-10.449-10.449-10.449z" />
          <path d="M243.734 171.709c0 5.771 4.679 10.449 10.449 10.449h78.79c5.77 0 10.449-4.678 10.449-10.449s-4.679-10.449-10.449-10.449h-78.789c-5.771 0-10.449 4.678-10.449 10.449z" />
          <path d="M230.02 123.848a10.45 10.45 0 0014.776 0l24.163-24.162a10.45 10.45 0 000-14.777 10.45 10.45 0 00-14.778 0l-24.163 24.162a10.45 10.45 0 000 14.777z" />
          <path d="M273.326 80.543a10.45 10.45 0 0014.776 0l12.404-12.404a10.45 10.45 0 000-14.777 10.45 10.45 0 00-14.778 0l-12.403 12.403a10.45 10.45 0 000 14.777z" />
          <path d="M171.711 99.681c5.771 0 10.449-4.679 10.449-10.449l-.001-78.782c0-5.771-4.679-10.449-10.449-10.449-5.771 0-10.449 4.679-10.449 10.449l.001 78.782c0 5.771 4.679 10.449 10.449 10.449z" />
        </svg>
      );
    case 'brush':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" className={cn} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
          <path d="m9.06 11.9 8.07-8.06a2.85 2.85 0 1 1 4.03 4.03l-8.06 8.08" />
          <path d="M7.07 14.94c-1.66 0-3 1.35-3 3.02 0 1.33-2.5 1.52-2 2.02 1.08 1.1 2.49 2.02 4 2.02 2.2 0 4-1.8 4-4.04a3.01 3.01 0 0 0-3-3.02z" />
        </svg>
      );
    case 'eraser':
      return (
        <svg
          className={cn}
          viewBox="0 0 24 24"
          fill="currentColor"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* top shape */}
          <path
            opacity="0.5"
            d="M14.95 3c-1.04 0-1.87.83-3.54 2.5L6.5 10.41 13.59 17.5l4.91-4.91C20.17 10.92 21 10.09 21 9.05c0-1.04-.83-1.87-2.5-3.54C16.82 3.83 15.99 3 14.95 3z"
          />

          {/* bottom shape */}
          <path d="M13.59 17.5 6.5 10.41l-1 1C3.83 13.08 3 13.91 3 14.95c0 1.04.83 1.87 2.5 3.55C7.17 20.17 8.01 21 9.05 21c1.04 0 1.87-.83 3.54-2.5l1-1z" />

          {/* base line */}
          <path
            opacity="0.5"
            d="M9.06 21c.8 0 1.48-.5 2.51-1.5H21a.75.75 0 010 1.5H9.06z"
          />
        </svg>


      );
    case 'move':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" className={cn} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
          <path d="m5 9-3 3 3 3" />
          <path d="m9 5 3-3 3 3" />
          <path d="m15 19-3 3-3-3" />
          <path d="m19 9 3 3-3 3" />
          <path d="M2 12h20" />
          <path d="M12 2v20" />
        </svg>
      );
    case 'zoomBoth':
      return (
        <span className={`inline-flex items-center gap-0.5 ${className}`.trim()} aria-hidden>
          <svg xmlns="http://www.w3.org/2000/svg" className="w-[16px] h-[16px] text-amber-900" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="11" cy="11" r="8" />
            <path d="m21 21-4.3-4.3" />
            <path d="M11 8v6" />
            <path d="M8 11h6" />
          </svg>
          <svg xmlns="http://www.w3.org/2000/svg" className="w-[16px] h-[16px] text-amber-900" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="11" cy="11" r="8" />
            <path d="m21 21-4.3-4.3" />
            <path d="M8 11h6" />
          </svg>
        </span>
      );
    case 'brushOrWand':
      return (
        <span className={`inline-flex items-center gap-1 shrink-0 text-amber-900 ${className}`.trim()} aria-hidden>
          <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="m9.06 11.9 8.07-8.06a2.85 2.85 0 1 1 4.03 4.03l-8.06 8.08" />
            <path d="M7.07 14.94c-1.66 0-3 1.35-3 3.02 0 1.33-2.5 1.52-2 2.02 1.08 1.1 2.49 2.02 4 2.02 2.2 0 4-1.8 4-4.04a3.01 3.01 0 0 0-3-3.02z" />
          </svg>
          <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" viewBox="0 0 24 24" fill="none" aria-hidden>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8.99999 1C8.99999 0.447715 8.55228 0 7.99999 0C7.44771 0 6.99999 0.447715 6.99999 1V1.5C6.99999 2.05228 7.44771 2.5 7.99999 2.5C8.55228 2.5 8.99999 2.05228 8.99999 1.5V1ZM3.7071 2.29289C3.31657 1.90237 2.68341 1.90237 2.29288 2.29289C1.90236 2.68342 1.90236 3.31658 2.29288 3.70711L3.29288 4.70711C3.68341 5.09763 4.31657 5.09763 4.7071 4.70711C5.09762 4.31658 5.09762 3.68342 4.7071 3.29289L3.7071 2.29289ZM13.7071 3.70711C14.0976 3.31658 14.0976 2.68342 13.7071 2.29289C13.3166 1.90237 12.6834 1.90237 12.2929 2.29289L11.2929 3.29289C10.9024 3.68342 10.9024 4.31658 11.2929 4.70711C11.6834 5.09763 12.3166 5.09763 12.7071 4.70711L13.7071 3.70711ZM1 7C0.447715 7 0 7.44772 0 8C0 8.55228 0.447715 9 1 9H1.5C2.05228 9 2.5 8.55228 2.5 8C2.5 7.44772 2.05228 7 1.5 7H1ZM15 7C14.4477 7 14 7.44772 14 8C14 8.55228 14.4477 9 15 9H15.5C16.0523 9 16.5 8.55228 16.5 8C16.5 7.44772 16.0523 7 15.5 7H15ZM4.70711 12.7071C5.09763 12.3166 5.09763 11.6834 4.70711 11.2929C4.31658 10.9024 3.68342 10.9024 3.29289 11.2929L2.29289 12.2929C1.90237 12.6834 1.90237 13.3166 2.29289 13.7071C2.68342 14.0976 3.31658 14.0976 3.70711 13.7071L4.70711 12.7071ZM9 15C9 14.4477 8.55228 14 8 14C7.44772 14 7 14.4477 7 15V15.5C7 16.0523 7.44772 16.5 8 16.5C8.55228 16.5 9 16.0523 9 15.5V15ZM9.41421 4.99998C8.63316 4.21894 7.36683 4.21894 6.58579 4.99998L5 6.58577C4.21895 7.36682 4.21895 8.63315 5 9.4142L7.29289 11.7071L18.5858 23C19.3668 23.781 20.6332 23.781 21.4142 23L23 21.4142C23.781 20.6331 23.781 19.3668 23 18.5858L11.7071 7.29288L9.41421 4.99998ZM6.41421 7.99998L8 6.4142L9.58579 7.99998L8 9.58577L6.41421 7.99998ZM9.41421 11L11 9.4142L21.5858 20L20 21.5858L9.41421 11Z"
              fill="currentColor"
            />
          </svg>
        </span>
      );
    default:
      return null;
  }
}

/**
 * Photorealistic view — contextual helpful tips.
 * Add new entries to PHOTOREALISTIC_TIP_DEFINITIONS; each tip uses `when(context)` to decide visibility.
 * Sections are shown one-at-a-time as carousel slides; last slide shows a close control.
 */

/** @typedef {{ hasActivePolygonOnCanvas: boolean, isMagicWandActive?: boolean, isEraserActive?: boolean, isBrushActive?: boolean, isMoveToolActive?: boolean, hasTriggeredZoomToolbarTips?: boolean, zoomToolbarTipsEpoch?: number, panToolbarTipsEpoch?: number, showCuratedSavePromptTip?: boolean, curatedSavePromptTipEpoch?: number }} PhotorealisticTipsContext */

export const PHOTOREALISTIC_TIP_IDS = {
  /** Shown when user has a polygon visible on the canvas (selected / show-all / editing). */
  EDITING_SELECTION: 'editing_selection',
  /** Shown when user activates magic wand tool. */
  MAGIC_WAND: 'magic_wand',
  /** Shown when user activates eraser tool. */
  ERASER: 'eraser',
  /** Shown when user activates brush tool. */
  BRUSH: 'brush',
  /** After user clicks zoom +/− on the editor toolbar while editing. */
  ZOOM_TOOLBAR: 'zoom_toolbar',
  /** When user activates Move (pan) tool — mutually exclusive with zoom-toolbar tips while zoom flag is set. */
  PAN_TOOL: 'pan_tool',
  /** After curated models are combined and saved — nudge user to the Prompt chat. */
  CURATED_SAVE_PROMPT: 'curated_save_prompt',
};

/**
 * @type {Array<{
 *   id: string,
 *   when: (ctx: PhotorealisticTipsContext) => boolean,
 *   sections: Array<{ emoji?: string, toolIcon?: 'magicwand' | 'brush' | 'eraser' | 'move' | 'zoomBoth' | 'brushOrWand', title: string, body: string }>,
 * }>}
 */
export const PHOTOREALISTIC_TIP_DEFINITIONS = [
  {
    id: PHOTOREALISTIC_TIP_IDS.EDITING_SELECTION,
    when: (ctx) =>
      Boolean(ctx?.hasActivePolygonOnCanvas) &&
      !Boolean(ctx?.isMagicWandActive) &&
      !Boolean(ctx?.isEraserActive) &&
      !Boolean(ctx?.isBrushActive) &&
      !Boolean(ctx?.isMoveToolActive),
    sections: [
      {
        emoji: '💡',
        title: 'Pro-Tip: Editing your selection',
        body:
          'To refine this mask, locate the object under Detected Objects and click the Brush Icon. To remove the selection entirely, click the Trash Icon.',
      },
      {
        emoji: '⚠️',
        title: 'Note:',
        body:
          'If you delete the entire selection, the AI will no longer detect or process this object in your final result.',
      },
    ],
  },
  {
    id: PHOTOREALISTIC_TIP_IDS.MAGIC_WAND,
    when: (ctx) => Boolean(ctx?.isMagicWandActive),
    sections: [
      {
        toolIcon: 'magicwand',
        title: 'Magic Wand Tool (M)',
        body:
          '1. Place Points: Click parts of the object you want to select. You can set up to 10 points.',
      },
      {
        toolIcon: 'magicwand',
        title: 'Magic Wand Tool (M)',
        body:
          '2. Apply: Click the [Apply Mask] button to let the AI wrap the selection.',
      },
      {
        toolIcon: 'magicwand',
        title: 'Magic Wand Tool (M)',
        body:
          '3. Refine: Use the Add/Remove toggles to fine-tune the edges.',
      },
      {
        toolIcon: 'magicwand',
        title: 'Magic Wand Tool (M)',
        body:
          '4. Confirm: Once you are happy with the mask, click the [Confirm Selection] button on the right to save it.',
      },
    ],
  },
  {
    id: PHOTOREALISTIC_TIP_IDS.ERASER,
    when: (ctx) => Boolean(ctx?.isEraserActive),
    sections: [
      {
        toolIcon: 'eraser',
        title: 'Eraser Tool (E)',
        body:
          '1. Remove Areas: Click and drag over any part of the mask you want to delete. This is perfect for cleaning up edges or fixing overlaps.',
      },
      {
        toolIcon: 'eraser',
        title: 'Eraser Tool (E)',
        body:
          '2. Adjust Size: Use the Slider in the toolbar to switch between a large eraser for quick fixes or a small one for precision.',
      },
      {
        toolIcon: 'eraser',
        title: 'Eraser Tool (E)',
        body:
          '3. Confirm: Once your mask looks perfect, click the [Confirm Selection] button to save your changes.',
      },
    ],
  },
  {
    id: PHOTOREALISTIC_TIP_IDS.BRUSH,
    when: (ctx) => Boolean(ctx?.isBrushActive),
    sections: [
      {
        emoji: '🖌️',
        title: 'Brush Tool (B)',
        body:
          '1. Paint Your Mask: Click and drag your cursor over the object you want to select. The highlighted area is where the AI will focus.',
      },
      {
        emoji: '🖌️',
        title: 'Brush Tool (B)',
        body:
          '2. Adjust Size: Use the Slider in the toolbar to change your brush thickness for broad strokes or fine details.',
      },
      {
        emoji: '🖌️',
        title: 'Brush Tool (B)',
        body:
          '3. Confirm: Once the object is fully covered, click the [Confirm Selection] button to save your mask.',
      },
    ],
  },
  {
    id: PHOTOREALISTIC_TIP_IDS.ZOOM_TOOLBAR,
    when: (ctx) => Boolean(ctx?.hasTriggeredZoomToolbarTips),
    sections: [
      {
        toolIcon: 'zoomBoth',
        title: 'Zoom (Mouse Wheel)',
        body:
          '1. Magnify: Use the + and − zoom buttons on the toolbar to zoom in for detail or zoom out to see the full room.',
      },
      {
        toolIcon: 'zoomBoth',
        title: 'Zoom (Mouse Wheel)',
        body:
          '2. Switch Back: When you’re done adjusting the view, click the Brush or Magic Wand icon to resume editing.',
      },
    ],
  },
  {
    id: PHOTOREALISTIC_TIP_IDS.PAN_TOOL,
    when: (ctx) =>
      Boolean(ctx?.isMoveToolActive) && !Boolean(ctx?.hasTriggeredZoomToolbarTips),
    sections: [
      {
        toolIcon: 'move',
        title: 'Pan (Space)',
        body:
          '1. Move Canvas: Click and drag anywhere on the image to pan the view. This helps you reach corners without changing your mask.',
      },
      {
        toolIcon: 'move',
        title: 'Pan (Space)',
        body:
          '2. Switch Back: Click the Brush or Magic Wand icon to resume editing.',
      },
    ],
  },
  {
    id: PHOTOREALISTIC_TIP_IDS.CURATED_SAVE_PROMPT,
    when: (ctx) => Boolean(ctx?.showCuratedSavePromptTip),
    sections: [
      {
        emoji: '✨',
        title: 'Enhance with AI',
        body:
          'After saving the image you can enhance it with our AI Photorealistic chat',
      },
    ],
  },
];

/**
 * @param {PhotorealisticTipsContext} context
 * @returns {typeof PHOTOREALISTIC_TIP_DEFINITIONS}
 */
export function resolvePhotorealisticTips(context) {
  return PHOTOREALISTIC_TIP_DEFINITIONS.filter((def) => {
    try {
      return def.when(context);
    } catch {
      return false;
    }
  });
}

/**
 * Flatten matching tips into ordered slides (one section = one slide).
 * @param {PhotorealisticTipsContext} context
 */
export function getPhotorealisticTipSlides(context) {
  let tips = resolvePhotorealisticTips(context);
  if (Boolean(context?.showCuratedSavePromptTip)) {
    tips = tips.filter((t) => t.id === PHOTOREALISTIC_TIP_IDS.CURATED_SAVE_PROMPT);
  } else if (Boolean(context?.hasTriggeredZoomToolbarTips)) {
    // Zoom toolbar (+/−) should show Zoom & Pan tips even if Brush/Eraser/Wand are also "active".
    // Without this filter, those tool tips would stack ahead of Zoom & Pan in the carousel.
    tips = tips.filter((t) => t.id === PHOTOREALISTIC_TIP_IDS.ZOOM_TOOLBAR);
  }
  return tips.flatMap((tip) =>
    tip.sections.map((sec, i) => ({
      key: `${tip.id}-${i}`,
      tipId: tip.id,
      ...sec,
    }))
  );
}

/**
 * Carousel panel: one section per slide, Next between slides, close on last slide.
 * @param {{ context: PhotorealisticTipsContext, className?: string }} props
 */
export function PhotorealisticHelpfulTipsPanel({ context, className = '' }) {
  const slides = useMemo(() => getPhotorealisticTipSlides(context), [context]);
  const [slideIndex, setSlideIndex] = useState(0);
  const [dismissedTipIds, setDismissedTipIds] = useState([]);
  const visibleSlides = useMemo(
    () => slides.filter((s) => !dismissedTipIds.includes(s.tipId)),
    [slides, dismissedTipIds]
  );
  const visibleTipSignature = useMemo(
    () => Array.from(new Set(visibleSlides.map((s) => s.tipId))).join('|'),
    [visibleSlides]
  );

  const active =
    Boolean(context?.hasActivePolygonOnCanvas) ||
    Boolean(context?.isMagicWandActive) ||
    Boolean(context?.isEraserActive) ||
    Boolean(context?.isBrushActive) ||
    Boolean(context?.isMoveToolActive) ||
    Boolean(context?.hasTriggeredZoomToolbarTips) ||
    Boolean(context?.showCuratedSavePromptTip);

  useEffect(() => {
    if (!active) {
      setDismissedTipIds([]);
      setSlideIndex(0);
    }
  }, [active]);

  useEffect(() => {
    const epoch = context?.zoomToolbarTipsEpoch;
    if (epoch == null || epoch <= 0) return;
    setDismissedTipIds((prev) => prev.filter((id) => id !== PHOTOREALISTIC_TIP_IDS.ZOOM_TOOLBAR));
    setSlideIndex(0);
  }, [context?.zoomToolbarTipsEpoch]);

  useEffect(() => {
    const epoch = context?.panToolbarTipsEpoch;
    if (epoch == null || epoch <= 0) return;
    setDismissedTipIds((prev) => prev.filter((id) => id !== PHOTOREALISTIC_TIP_IDS.PAN_TOOL));
    setSlideIndex(0);
  }, [context?.panToolbarTipsEpoch]);

  useEffect(() => {
    const epoch = context?.curatedSavePromptTipEpoch;
    if (epoch == null || epoch <= 0) return;
    setDismissedTipIds((prev) =>
      prev.filter((id) => id !== PHOTOREALISTIC_TIP_IDS.CURATED_SAVE_PROMPT),
    );
    setSlideIndex(0);
  }, [context?.curatedSavePromptTipEpoch]);

  useEffect(() => {
    if (visibleSlides.length === 0) {
      setSlideIndex(0);
      return;
    }
    setSlideIndex((i) => Math.min(i, visibleSlides.length - 1));
  }, [visibleSlides.length]);

  useEffect(() => {
    // When tip family changes (e.g. Brush -> Eraser), start from first slide.
    setSlideIndex(0);
  }, [visibleTipSignature]);

  useEffect(() => {
    if (visibleSlides.length <= 1) return;
    const isLast = slideIndex >= visibleSlides.length - 1;
    if (isLast) return;

    const timer = window.setTimeout(() => {
      setSlideIndex((i) => Math.min(i + 1, visibleSlides.length - 1));
    }, 7000);

    return () => window.clearTimeout(timer);
  }, [slideIndex, visibleSlides.length]);

  if (visibleSlides.length === 0) return null;

  const isLast = slideIndex >= visibleSlides.length - 1;
  const slidePct = 100 / visibleSlides.length;
  const currentSlide = visibleSlides[slideIndex] ?? null;

  return (
    <div
      className={`shrink-0 rounded-lg border backdrop-blur-xl backdrop-saturate-150 border-white/50 bg-white/35 shadow-sm ${className}`}
      role="region"
      aria-label="Helpful tips"
    >
      <div className="flex items-start justify-between gap-2 px-3 pt-2.5 pb-1">
        <p className="text-xs font-semibold uppercase tracking-wide text-gray-700 mb-2">Helpful Tips</p>
        {isLast ? (
          <button
            type="button"
            onClick={() => {
              if (!currentSlide?.tipId) return;
              setDismissedTipIds((prev) =>
                prev.includes(currentSlide.tipId) ? prev : [...prev, currentSlide.tipId]
              );
            }}
            className="shrink-0 rounded text-amber-900/70 hover:text-gray-600 transition-colors"
            aria-label="Close helpful tips"
            title="Close"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        ) : (
          <span className="w-7 shrink-0" aria-hidden />
        )}
      </div>

      {/* Track is n× viewport wide; each slide is 1/n of track = full card width — prevents adjacent slide peeking */}
      <div className="w-full overflow-hidden">
        <div
          className="flex transition-transform duration-300 ease-out"
          style={{
            width: `${visibleSlides.length * 100}%`,
            transform: `translateX(-${slideIndex * slidePct}%)`,
          }}
        >
          {visibleSlides.map((sec) => (
            <div
              key={sec.key}
              className="shrink-0 min-h-[5.5rem] box-border pr-1 px-3"
              style={{ width: `${slidePct}%` }}
            >
              <div className="text-sm text-gray-800 max-w-full">
                <p className="font-semibold text-gray-900 flex items-center gap-1 min-w-0">
                  {sec.toolIcon ? (
                    <TipToolIcon name={sec.toolIcon} />
                  ) : sec.emoji ? (
                    <span className="shrink-0" aria-hidden>
                      {sec.emoji}
                    </span>
                  ) : null}
                  <span className="min-w-0">{sec.title}</span>
                </p>
                <p className="mt-1 text-gray-700 leading-snug">{sec.body}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="flex items-center gap-2 px-3 pb-2.5 pt-2">
        <div className="flex flex-1 items-center gap-1" role="tablist" aria-label="Tip slides">
          {visibleSlides.map((s, i) => (
            <button
              key={s.key}
              type="button"
              onClick={() => setSlideIndex(i)}
              className={`h-1.5 rounded-full transition-all ${i === slideIndex ? 'w-4 bg-[#84acc9]' : 'w-1.5 bg-[#bde2fc] hover:bg-[#a9cde8]'}`}
              aria-label={`Go to tip ${i + 1} of ${slides.length}`}
              aria-current={i === slideIndex ? 'true' : undefined}
            />
          ))}
        </div>
        {slideIndex > 0 ? (
          <button
            type="button"
            onClick={() => setSlideIndex((i) => Math.max(i - 1, 0))}
            className="shrink-0 text-xs font-semibold text-gray-700 hover:text-amber-950 px-1 py-1 rounded-md  transition-colors"
            aria-label="Previous tip"
          >
            ←
          </button>
        ) : null}

        {!isLast ? (
          <button
            type="button"
            onClick={() => setSlideIndex((i) => Math.min(i + 1, visibleSlides.length - 1))}
            className="shrink-0 text-xs font-semibold text-gray-700 hover:text-amber-950 px-1 py-1 rounded-md  transition-colors"
            aria-label="Next tip"
          >
            →
          </button>
        ) : null}
      </div>
    </div>
  );
}
